var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusWhiteBackBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5518_243)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.333 48.2424L56.3323 33.6528C56.2681 32.6414 55.8212 31.6928 55.0824 30.9997C54.3436 30.3067 53.3683 29.9212 52.3548 29.9217C51.3414 29.9222 50.3658 30.3085 49.6263 31.0023C48.8869 31.696 48.4391 32.645 48.374 33.6565L48.3597 48.2461L33.7344 48.251C33.2106 48.2512 32.6919 48.3546 32.2079 48.5553C31.7239 48.756 31.284 49.05 30.9135 49.4205C30.5429 49.791 30.2489 50.2309 30.0483 50.7149C29.8476 51.1989 29.7442 51.7176 29.744 52.2414C29.7437 52.7652 29.8466 53.2838 30.0469 53.7676C30.2471 54.2514 30.5407 54.691 30.9109 55.0612C31.2811 55.4314 31.7206 55.725 32.2044 55.9252C32.6883 56.1254 33.2069 56.2283 33.7307 56.2281L48.356 56.2194L48.3549 70.8071C48.3243 71.3487 48.4045 71.8907 48.5906 72.4C48.7767 72.9093 49.0649 73.3752 49.4373 73.7691C49.8098 74.163 50.2588 74.4768 50.7568 74.6911C51.2549 74.9054 51.7915 75.0158 52.3339 75.0156C52.8763 75.0153 53.4131 74.9044 53.9113 74.6896C54.4096 74.4748 54.8589 74.1607 55.2317 73.7664C55.6046 73.3721 55.8931 72.906 56.0797 72.3965C56.2663 71.8871 56.347 71.345 56.3169 70.8035L56.3293 56.2157L70.9095 56.2108C71.9674 56.2104 72.9821 55.7897 73.7304 55.0413C74.4788 54.293 74.8995 53.2783 74.8999 52.2204C74.9004 51.1626 74.4807 50.1483 73.733 49.4007C72.9854 48.653 71.9711 48.2333 70.9132 48.2337L56.333 48.2424Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5518_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhiteBackBlack);
export default __webpack_public_path__ + "static/media/plus-white-back-black.396acf081c47c18bcb600cf75de37ce7.svg";
export { ForwardRef as ReactComponent };